import { ITheme, IStyle, mergeStyleSets, getTheme } from '@fluentui/react';
import React, { useEffect, useRef, useState } from 'react';
import { SteppedListSection, StepSectionState } from '../../../components/step-section';
import { PaymentElement, useElements } from '@stripe/react-stripe-js';
import { StripeElements, StripePaymentElementChangeEvent } from '@stripe/stripe-js';
import { BwjButton, BwjButtonType } from '../../../../../framework/components/bwj-button';

interface IPaymentSectionCardInfoProps {
  state: StepSectionState;
  blockPaymentSubmission: boolean;
  onEditSection: () => void;
  onCompletePayment: (elements: StripeElements | null) => void;
  onFormChanged: () => void;
}

const getStyleClasses = (theme: ITheme) => {
  const buttonContainer: IStyle = {
    marginTop: '1rem',

    '& button': {
      width: '100%',
    }
  };

  return mergeStyleSets({
    buttonContainer,
  });
}

export const PaymentSectionCardInfo: React.FunctionComponent<IPaymentSectionCardInfoProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme);
  const elements = useElements();
  const [formComplete, setFormComplete] = useState(false);
  const [formInvalid, setFormInvalid] = useState(true);
  const changeReported = useRef(false);
  const { state } = props;
  useEffect(() => {
    if(state === StepSectionState.Active) {
      changeReported.current = false;
    }
  }, [state]);

  const onInfoChange = (event: StripePaymentElementChangeEvent) => {
    setFormComplete(event.complete);
    setFormInvalid(false);

    // we only need to report this once after this section becomes active, because
    // once reported, user can't move until they hit continue
    if(changeReported.current) { return; }
    changeReported.current = true;
    props.onFormChanged();
  }

  const onAdvanceToNextSection = () => {
    if(!elements) { return; }
    const cardInfo = elements.getElement('payment');
    if(!cardInfo) { return; }

    elements.submit()
    .then(result => {
      if(!result.error) {
        props.onCompletePayment(elements);
      } else {
        setFormInvalid(true);
      }
    });
  };

  return (
    <SteppedListSection
      id={'stnBillAddress'}
      title={'Payment Information'}
      state={props.state}
      formBusy={false}
      onEditSection={props.onEditSection}
    >
      <PaymentElement
        options={{ 
          layout: 'accordion',
          business: { name: 'BWJ Storm' },
          fields: {
            billingDetails: { address: 'never' },
          },
          wallets: {
            applePay: 'auto',
            googlePay: 'auto',
            link: 'auto',
          },
          paymentMethodOrder: [ 'card', 'apple_pay', 'google_pay', 'klarna', 'amazon_pay', 'link'],
         }}
        onChange={onInfoChange}
      />
      <div className={cs.buttonContainer}>
        <BwjButton
          buttonStyle={BwjButtonType.PrimaryStandard}
          text={'Place your order'}
          disabled={formComplete === false || formInvalid || props.blockPaymentSubmission}
          onClick={onAdvanceToNextSection}
        />
      </div>
    </SteppedListSection>
  );
};
